// directives/click-outside.js
export default {
    mounted(el, binding) {
      el._clickOutsideHandler = (event) => {
        const clickedEl = event.target;

        const clickedInside = el.contains(clickedEl);
  
        // Also skip if clicked element is marked as excluded
        const isExplicitlyIgnored = clickedEl.closest('[data-ignore-outside]');
        console.log
        if (clickedInside || isExplicitlyIgnored) return;
  
        binding.value(event); // Run the outside click handler
      };
  
      document.addEventListener('click', el._clickOutsideHandler);
    },
  
    unmounted(el) {
      document.removeEventListener('click', el._clickOutsideHandler);
    },
  };
  

